import {RouterModule, Routes} from '@angular/router';
import {ConsultaResolutivoComponent} from './consulta-resolutivo/portal.consulta-resolutivo.component';
import {NgModule} from '@angular/core';

const exampleRoutes: Routes = [
  {
    path: '',
    component: ConsultaResolutivoComponent,
    data: {
      pageTitle: 'Consulta de Resolutivo'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(exampleRoutes)],
  exports: [RouterModule]
})
export class ConsultaResolutivoRouting {
}
